/* eslint max-len: off */
import React from 'react';
import {Icon} from '../createSvg';
import {IconProps} from '../types';

export const Facebook = (props: IconProps) => (
  <Icon {...props}>
    <path
      d="m13.397 20.997v-8.196h2.765l.411-3.20895h-3.176v-2.044c0-.926.258-1.56 1.587-1.56h1.684v-2.861c-.8194-.08781-1.643-.13021-2.467-.127-2.444 0-4.122 1.492-4.122 4.231v2.355h-2.747v3.20895h2.753v8.202z"
    />
  </Icon>
);
